import { UserEntityResolver } from 'app/shared/components/entity-resolvers/user.entity-resolver';
import { LicenseEntityResolver } from 'app/shared/components/entity-resolvers/license.entity-resolver';
import { CurrentUserEntityResolver } from 'app/shared/components/entity-resolvers/current-user.entity-resolver';
import { RoleEntityResolver } from 'app/shared/components/entity-resolvers/role.entity-resolver';
import { PermissionsetEntityResolver } from 'app/shared/components/entity-resolvers/permissionset.entity-resolver';
import { PermissionEntityResolver } from './shared/components/entity-resolvers/permission.entity-resolver';

export interface EntityResolverList {
  [name: string]: any;
}

export const EntityResolverTypes = {
  user: 'user',
  currentUser: 'currentUser',
  license: 'license',
  role: 'role',
  permissionSet: 'permissionSet',
  permission: 'permission',
};

// compose the list of resolvers
const resolvers = {};
resolvers[EntityResolverTypes.user] = UserEntityResolver;
resolvers[EntityResolverTypes.currentUser] = CurrentUserEntityResolver;
resolvers[EntityResolverTypes.license] = LicenseEntityResolver;
resolvers[EntityResolverTypes.role] = RoleEntityResolver;
resolvers[EntityResolverTypes.permissionSet] = PermissionsetEntityResolver;
resolvers[EntityResolverTypes.permission] = PermissionEntityResolver;

export const entityResolvers: EntityResolverList = resolvers;
